module.exports = __webpack_public_path__ + "images/emoji/purse.ff86071f909efd7aba1c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/purse.png
// module id = vu0p
// module chunks = 1